import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'
import { useCallback, useState } from 'react'

import { useRequestEmailChange } from '../../../api'
import { AuthLayout, ChangeEmail, ChangeEmailSubmitInput } from '../../../components'
import { ERROR_MESSAGES } from '../../../utils/errorMessages'
import { isSafeRedirect } from '../../../utils/redirect-url'

const RETURN_URL = '/configuracoes'

function buildConfirmationSentUrl(newEmail: string): string {
  const search = `?email=${encodeURIComponent(newEmail)}`
  return `/configuracoes/alterar-email/confirmacao-enviada${search}`
}

export interface ChangeEmailPageProps {
  currentEmail?: string
}

export function ChangeEmailPage({ currentEmail }: ChangeEmailPageProps) {
  const router = useRouter()
  const { execute, loading } = useRequestEmailChange()
  const [error, setError] = useState<string | undefined>()

  const handleCancel = useCallback(() => {
    const next = router.query.next_url as string | undefined
    const back = next && isSafeRedirect(next) ? next : RETURN_URL
    window.location.assign(back)
  }, [router.query.next_url])

  const handleSubmit = useCallback(
    async (input: ChangeEmailSubmitInput) => {
      setError(undefined)
      const result = await execute({ newEmail: input.newEmail })

      if (result.success) {
        window.location.assign(buildConfirmationSentUrl(input.newEmail))
        return
      }

      setError(
        result.kind === 'blockedByPartnership'
          ? ERROR_MESSAGES.changeEmail.server.blockedByPartnership
          : ERROR_MESSAGES.changeEmail.server.generic
      )
    },
    [execute]
  )

  return (
    <AuthLayout>
      <ChangeEmail
        currentEmail={currentEmail}
        isLoading={loading}
        error={error}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  ctx.res?.setHeader('Cache-Control', 'no-cache, no-transform')
  ctx.res?.setHeader('X-Robots-Tag', 'noindex')

  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
    },
  }
}

export const ChangeEmailPageExports = {
  getServerSideProps,
}
